import { createContext } from "react";

const LiveCacheContext = createContext({});

export default LiveCacheContext;
